import { z } from 'zod';

const strengthEntrySchema = z.object({
  id: z.string(),
  strength: z.string(),
  price: z.string(),
  weight: z.string().optional(),
  nrv_percent: z.string().optional(),
});

export const supplementFormSchema = z
  .object({
    name: z.string().min(1, 'Name is required'),
    strengths: z.array(strengthEntrySchema),
  })
  .refine(
    (data) =>
      data.strengths.some((s) => {
        const trimmedPrice = s.price.replace(',', '.');
        return (
          s.strength.trim() !== '' &&
          trimmedPrice !== '' &&
          !Number.isNaN(parseFloat(trimmedPrice)) &&
          parseFloat(trimmedPrice) >= 0
        );
      }),
    {
      message: 'Add at least one strength with a valid price',
      path: ['strengths'],
    },
  );

export type SupplementFormValues = z.infer<typeof supplementFormSchema>;
